const teaserBlockFilters = (() => {
    const initBlock = (el) => {
        const filtersWrapper = el.querySelector('[data-filters]');
        const teasers = el.querySelectorAll('[data-categories]');
        if (filtersWrapper && teasers){
            filtersWrapper.querySelectorAll('[data-filter]').forEach(filter => {
                filter.addEventListener('click', () => {
                    filtersWrapper.querySelectorAll('[data-filter]')
                        .forEach(filterItem => filterItem.classList.remove('underline'));
                    filter.classList.add('underline');
                    const value = filter.dataset.filter;
                    if (value === 'all'){
                        teasers.forEach(teaser => {
                            teaser.classList.remove('hidden');
                            teaser.classList.add('flex');
                        });
                    }else{
                        teasers.forEach(teaser => {
                            const teaserCategories = teaser.dataset.categories;
                            if (teaserCategories.includes(value)){
                                teaser.classList.remove('hidden');
                                teaser.classList.add('flex');
                            }else{
                                teaser.classList.add('hidden');
                                teaser.classList.remove('flex');
                            }
                        });
                    }
                });
            });            
        }
    };
    return {initBlock};
})();

document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('[data-teaser-block]').forEach(item => teaserBlockFilters.initBlock(item));
});
